module.exports = __webpack_public_path__ + "img/img04.33a39892.svg";